<div class="download-dialog">
  <h2 mat-dialog-title>Porta un amico in Beizy!</h2>

  <mat-dialog-content>
    <p>
      Se porti un amico in Beizy, lo renderai felice due volte: sia perchè sta per conoscere la velocità e la comodità di un <strong>vero Commercialista online,</strong> sia perchè avrete entrambi <strong>uno sconto!</strong>
    </p>

    <!-- Illustrazione: icona chiusa nel tondo bianco bordato nero, come le
         icone in evidenza del resto dell'app. -->
    <div class="success-container">
      <span class="izy-hero-icon">
        <mat-icon class="success-icon">diversity_1</mat-icon>
      </span>
      <p class="success-message mt-3 mb-0">
        Se lavori in compagnia, il risparmio di Beizy raddoppia!
      </p>
    </div>
  </mat-dialog-content>

  <!-- Barra delle azioni: fondo panna separato dal contenuto dal tratto nero
       2px, come il footer delle card. -->
  <mat-dialog-actions align="end" class="izy-dialog-actions">
    <button
      mat-stroked-button
      type="button"
      (click)="closeDialog()"
      class="izy-button-ghost custom-button-border">
      <mat-icon>close</mat-icon>
      Chiudi
    </button>

    <button
      mat-raised-button
      matButton="filled"
      type="button"
      class="ms-2 izy-button-primary custom-button-border"
      (click)="confirm()">
      Prosegui
      <mat-icon>arrow_circle_right</mat-icon>
    </button>
  </mat-dialog-actions>
</div>
